import styled from "styled-components";
import { ScrollBar } from "../../Theme/Hyper";
import { useContext, useState, useEffect } from "react";
import useLocalStorage from "../../Hooks/useLocalStorage";
import { GraphicsContext } from "../../contexts/GraphicsContext";
import { ControlContext } from "../../contexts/ControlContext";
import Select from "react-select";
import { DataContext } from "../../contexts/DataContext";
import { APIContext } from "../../contexts/APIContext";
import { IoMdReorder } from "react-icons/io";


const indicatorOptions = [
  { value: "same", label: "Same" },
  { value: "up", label: "Up" },
  { value: "down", label: "Down" },
  { value: "hide", label: "Hide" },
];

const HighlightOptions = [
  { value: "off", label: "Highlight Off" },
  { value: "white", label: "White Highlight" },
  { value: "gold", label: "Gold Highlight" },
  { value: "red", label: "Red Highlight" },
];

const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green ? "#0adb93" : props.red ? "#db0a41" : "#202731"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  height: 10%;
  width: 90%;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 1em;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  height: 60px;
  width: 120px;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
const Input = styled.input`
  background-color: rgb(34, 36, 43);
  border-radius: 4px;
  border: none;
  padding: 0 1em;
  outline: none;
  color: #fff;
  width: 160px;
  height: 40px;
`;

const HeaderInput = styled(Input)`
  font-weight: 600;
  color: #fff;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
    font-weight: 600;
  }
`;

const ActionPanel = styled(ScrollBar)`
  display: flex;
  margin-bottom: 1em;
  margin-right: 1em;
  box-sizing: border-box;
  min-height: 80vh;
  max-height: 90vh;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  flex-direction: column;
  position: relative;
`;
const SelectContainer = styled(Select)`
  min-width: 160px;
  margin-bottom: 0.5em;
  width: 100%;
`;
const Title = styled.div`
  display: flex;
  margin: 1em;
  justify-content: center;
  align-items: center;
  gap: 2rem;
  padding: 1.5rem;
  box-sizing: border-box;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.1);
  background-color: #181d25;

  .title-group {
    display: flex;
    align-items: center;
    gap: 0.5rem;
  }

  .label {
    display: flex;
    align-items: center;
    height: 40px;
  }

  input {
    height: 40px;
  }
`;

const TableHTML = styled.table`
  width: 100%;
  border-collapse: collapse;

  th {
    font-weight: bold;
  }

  th,
  td {
    text-align: left;
    vertical-align: middle;
    padding: 0.5rem 0.5rem;
  }

  th input,
  td input {
    width: 90%;
  }
`;

const DropdownStyles = {
  menu: (provided) => ({
    ...provided,
    backgroundColor: "rgb(34, 36, 43)",
  }),
  option: (provided, state) => {
    return {
      ...provided,
      backgroundColor: "rgb(34, 36, 43)",
      "&:hover": {
        color: "#db0a41",
      },
    };
  },
  control: (provided) => ({
    ...provided,
    backgroundColor: "rgb(34, 36, 43)",
    borderColor: "#384454",
  }),
  valueContainer: (provided) => ({
    ...provided,
    backgroundColor: "rgb(34, 36, 43)",
    borderColor: "#384454",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = "opacity 300ms";

    return { ...provided, opacity, transition, color: "#fff" };
  },
};

function ColumnToggle({ value, onChange }) {
  return (
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{
        background: "rgb(34, 36, 43)",
        color: "#fff",
        border: "none",
        borderRadius: 4,
        padding: "0.5em",
        width: "100%",
      }}
    >
      <option value="reg">Column Highlight Off</option>
      <option value="bold">Column Highlight On</option>
    </select>
  );
}

export default function Table({ game }) {
  const {
    previewGraphic,
    animateGraphic,
    graphicInPreview,
    animateOffGraphic,
    updateGraphic,
    clearPVW,
  } = useContext(GraphicsContext);

  const [selectedSeason, setSelectedSeason] = useState(null);
  const [season, setSeason] = useState(null);
  const { getSeasonTeams } = useContext(APIContext);
  useEffect(() => {
    getSeasonTeams({}).then((res) => {
      console.log("Apollo Result:", res);
      setSeason(res);
      if (res && res.length > 0 && !selectedSeason) {
        const defaultSeason = res.find((s) => s.name === "2026") || res.find((s) => s.name === "2025") || res[0];
        setSelectedSeason(defaultSeason);
        if (table[0].team === ""){
        const updatedTable = table.map((row, index) => {
        const teamData = defaultSeason.teams[index];
          return {
            ...row,
            team: teamData?.name || row.team,
            badge: teamData?.badge || row.badge,
            variables: teamData?.variables || row.variables,
          };
        });
        setTable(updatedTable); 
      }
    }
    });
  }, [getSeasonTeams, selectedSeason]);
  const [table, setTable] = useLocalStorage("hyper-netball-standings_v2", [
    {
      team: "",
      badge: "",
      position: 1,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
    {
      team: "",
      badge: "",
      position: 2,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
    {
      team: "",
      badge: "",
      position: 3,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
    {
      team: "",
      badge: "",
      position: 4,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
    {
      team: "",
      badge: "",
      position: 5,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
    {
      team: "",
      badge: "",
      position: 6,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
    {
      team: "",
      badge: "",
      position: 7,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
    {
      team: "",
      badge: "",
      position: 8,
      indicator: "same",
      Column2: 0,
      Column1: 0,
      Column3: 0,
      Column4: 0,
    },
  ]);
  const [headers, setheaders] = useState({
    position: "",
    indicator: "",
    team: "",
    Column1: "Pld",
    Column2: "Pts",
    Column3: "Won",
    Column4: "Lost",
  });
  const [title, setTitle] = useLocalStorage("hyper-netball-standings_title", "Super League");
  const [subtitle, setSubtitle] = useLocalStorage("hyper-netball-standings_subtitle", "");
  const [columnStyles, setColumnStyles] = useState({
    position: "reg",
    indicator: "reg",
    team: "reg",
    Column1: "reg",
    Column2: "bold",
    Column3: "reg",
    Column4: "reg",
  });
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  return (
    <ActionPanel>
      <Title>
        <div className="title-group">
          <span className="label">Title</span>
          <Input
            value={title}
            onChange={(e) =>
              setTitle(e.currentTarget.value)
            }
          />
        </div>
        <div className="title-group">
          <span className="label">Subtitle</span>
          <Input
            value={subtitle}
            onChange={(e) =>
              setSubtitle(e.currentTarget.value)
            }
          />
        </div>
        <div className="title-group">
          <span className="label">Select Season</span>
          <SelectContainer
            menuPortalTarget={document.body}
            styles={DropdownStyles}
            setSize={true}
            style={{ margin: "1em", width: "50%", zIndex: 9999, }}
            value={
              selectedSeason
                ? {
                    value: selectedSeason._id,
                    label: selectedSeason.name,
                  }
                : null
            }
            options={season?.map((s) => {
              return {
                value: s._id,
                label: s.name,
              };
            })}
            onChange={(e) => {
              const fullSeason = season.find((s) => s._id === e.value);
              setSelectedSeason(fullSeason);
              const updatedTable = table.map((row, index) => {
              const teamData = fullSeason.teams[index];
              return {...row, 
                team: teamData?.name || "", 
                badge: teamData?.variables?.Hyper_Badge || "",
                variables: teamData?.variables || {},
              };
            });
            setTable(updatedTable);}} 

            placeholder="Season"
          />
        </div>
      </Title>
      <TableHTML>
        <thead>
          <tr>
            <th>
            </th>
            <th>
              <Input
                value={headers.position}
                placeholder="Pos"
                onChange={(e) =>
                  setheaders({ ...headers, position: e.currentTarget.value })
                }
              />
            </th>
            <th>
              <HeaderInput
                value={headers.indicator}
                placeholder="Indicator"
                onChange={(e) =>
                  setheaders({ ...headers, indicator: e.currentTarget.value })
                }
              />
            </th>
            <th>
              <HeaderInput
                value={headers.team}
                placeholder="Team"
                onChange={(e) =>
                  setheaders({ ...headers, team: e.currentTarget.value })
                }
              />
            </th>
            <th>
              <HeaderInput
                value={headers.Column1}
                placeholder="Column 1 Header"
                onChange={(e) =>
                  setheaders({ ...headers, Column1: e.currentTarget.value })
                }
              />
            </th>
            <th>
              <HeaderInput
                value={headers.Column2}
                placeholder="Column 2 Header"
                onChange={(e) =>
                  setheaders({ ...headers, Column2: e.currentTarget.value })
                }
              />
            </th>
            <th>
              <HeaderInput
                value={headers.Column3}
                placeholder="Column 3 Header"
                onChange={(e) =>
                  setheaders({ ...headers, Column3: e.currentTarget.value })
                }
              />
            </th>
            <th>
              <HeaderInput
                value={headers.Column4}
                placeholder="Column 4 Header"
                onChange={(e) =>
                  setheaders({ ...headers, Column4: e.currentTarget.value })
                }
              />
            </th>
            <th>
              Row Highlight
            </th>
          </tr>
        </thead>
        <tbody>
          {table?.map((item, index) => {
            return (
              <Row
                key={index}
                item={item}
                index={index}
                season={season}
                selectedSeason={selectedSeason}
                onChange={(new_item) => {
                  let new_table = [...table];
                  new_table[index] = new_item;
                  setTable(new_table);
                }}
                onDragStart={(i) => setDraggedIndex(i)}
                draggedIndex={draggedIndex}
                dragOverIndex={dragOverIndex}
                onDragOver={(e) => {
                  e.preventDefault();
                  if (dragOverIndex !== index) {
                    setDragOverIndex(index);
                  }
                }}
                onDragLeave={() => { setDragOverIndex(null); }}
                onDrop={(i) => {
                  setDragOverIndex(null);
                  if (draggedIndex === null || draggedIndex === i) return;
                  setTable((prev) => {
                    const updated = [...prev];
                    const [moved] = updated.splice(draggedIndex, 1);
                    updated.splice(i, 0, moved);
                    return updated.map((row, idx) => ({
                      ...row,
                      position: idx + 1,
                    }));
                  });

                  setDraggedIndex(null);
                }}
              />
            );
          })}
        </tbody>
        <tfoot>
          <tr>
            <td></td>
            <td>
              <ColumnToggle
                value={columnStyles.position}
                onChange={(v) =>
                  setColumnStyles({ ...columnStyles, position: v })
                }
              />
            </td>

            <td>
              <ColumnToggle
                value={columnStyles.indicator}
                onChange={(v) =>
                  setColumnStyles({ ...columnStyles, indicator: v })
                }
              />
            </td>

            <td>
              <ColumnToggle
                value={columnStyles.team}
                onChange={(v) => setColumnStyles({ ...columnStyles, team: v })}
              />
            </td>

            <td>
              <ColumnToggle
                value={columnStyles.Column1}
                onChange={(v) =>
                  setColumnStyles({ ...columnStyles, Column1: v })
                }
              />
            </td>

            <td>
              <ColumnToggle
                value={columnStyles.Column2}
                onChange={(v) =>
                  setColumnStyles({ ...columnStyles, Column2: v })
                }
              />
            </td>

            <td>
              <ColumnToggle
                value={columnStyles.Column3}
                onChange={(v) => setColumnStyles({ ...columnStyles, Column3: v })}
              />
            </td>

            <td>
              <ColumnToggle
                value={columnStyles.Column4}
                onChange={(v) => setColumnStyles({ ...columnStyles, Column4: v })}
              />
            </td>
          </tr>
        </tfoot>
      </TableHTML>
      <Title>
        <GraphicButton
          onClick={() => {
            let new_table = JSON.parse(JSON.stringify(table)).sort((a, b) => {
              return parseInt(a?.position) - parseInt(b?.position);
            });
            setTable(new_table);
            previewGraphic("Table", {
              table: new_table,
              game,
              title: title,
              subtitle: subtitle,
              headers: headers,
              columnStyles: columnStyles,
            });
          }}
        >
          Preview
        </GraphicButton>
        <GraphicButton
          green
          onClick={() => {
            animateGraphic("Table", {});
          }}
        >
          IN
        </GraphicButton>
        <GraphicButton
          red
          onClick={() => {
            animateOffGraphic("Table");
          }}
        >
          OUT
        </GraphicButton>
      </Title>
    </ActionPanel>
  );
}

function Row({
  item,
  index,
  onChange,
  onDragStart,
  onDragOver,
  onDrop,
  selectedSeason,
  draggedIndex,
  dragOverIndex,
}) {
  const [isFocused, setIsFocused] = useState(false);
  let teams = selectedSeason?.teams || [];

  let translateY = 0;
  if (draggedIndex !== null && dragOverIndex !== null) {
    if (index === dragOverIndex && draggedIndex < index) {
      translateY = 10;
    } else if (index === dragOverIndex && draggedIndex > index) {
      translateY = -10;
    }
  }

  return (
    <tr
      draggable
      onDragStart={(e) => {
        if (e.target.tagName === "INPUT" || e.target.tagName === "SELECT") {
          e.preventDefault();
          return;
        }
        onDragStart(index);
      }}
      onDragOver={onDragOver}
      onDrop={() => onDrop(index)}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
      style={{
        position: "relative",
        zIndex: isFocused ? 1000 : (dragOverIndex === index ? 100 : 1),
        cursor: "grab",
        transform: `translateY(${translateY}px)`,
        transition: "transform 150ms ease, border 150ms ease",
        borderBottom: (index === dragOverIndex && draggedIndex < index) ? 
        "2px solid #db0a41" 
        : "none",
        borderTop: (index === dragOverIndex && draggedIndex > index) ? 
        "2px solid #0adb93" 
        : "none",
        backgroundColor: (dragOverIndex === index && draggedIndex !== null) ? "rgba(63, 6, 21, 0.07)" : "transparent",
      }}
      menuPlacement="auto"
    >
      <td
      style={{
        textAlign: "center",
        width: "40px",
      }}>
        <IoMdReorder />
      </td>
      <td>
        <Input
          value={item?.position}
          onChange={(e) => {
            onChange({ ...item, position: e.currentTarget.value });
          }}
        />
      </td>
      <td>
        <SelectContainer
          styles={DropdownStyles}
          setSize={true}
          value={indicatorOptions.find(
            (option) => option.value === (item?.indicator || "same"),
          )}
          options={indicatorOptions}
          onChange={(e) => {
            onChange({ ...item, indicator: e.value });
          }}
          placeholder="Same"
        />
      </td>
      <td>
        <SelectContainer
          styles={DropdownStyles}
          setSize={true}
          value={{
            value: item?.team,
            label: item?.team,
          }}
          options={teams?.map((t) => {
            return {
              value: t._id,
              label: t.name,
            };
          })}
          onChange={(e) => {
            const selectedTeamData = teams.find((t) => t._id === e.value);
            onChange({
              ...item,
              team: e.label,
              badge: selectedTeamData?.variables?.Hyper_Badge,
              variables: selectedTeamData?.variables,
            });
          }}
          placeholder="Team"
        />
      </td>
      <td>
        <Input
          value={item?.Column1}
          onChange={(e) => {
            onChange({ ...item, Column1: e.currentTarget.value });
          }}
        />
      </td>
      <td>
        <Input
          value={item?.Column2}
          onChange={(e) => {
            onChange({ ...item, Column2: e.currentTarget.value });
          }}
        />
      </td>
      <td>
        <Input
          value={item?.Column3}
          onChange={(e) => {
            onChange({ ...item, Column3: e.currentTarget.value });
          }}
        />
      </td>
      <td>
        <Input
          value={item?.Column4}
          onChange={(e) => {
            onChange({ ...item, Column4: e.currentTarget.value });
          }}
        />
      </td>
      <td>
        <SelectContainer
          styles={DropdownStyles}
          setSize={true}
          value={HighlightOptions.find(
            (option) => option.value === (item?.highlight || "Highlight off"),
          )}
          options={HighlightOptions}
          onChange={(e) => {
            onChange({ ...item, highlight: e.value });
          }}
          placeholder="Highlight off"
        />
      </td>
      <td>
      </td>
    </tr>
  );
}
